export default __webpack_public_path__ + "static/media/bgLogin.a1f0f6cc.jpg";